import { useI18n } from '@change-corgi/core/react/i18n';

import { usePetitionGuidesPageData } from 'src/app/pages/petitionGuides/pageContext';

type Result = ModelHookResult<{
	canonicalUrl: string;
	description: string;
	title: string;
	image: string;
}>;

export function usePageMeta(): Result {
	const {
		data: {
			heroImage: { url: heroImageUrl },
		},
	} = usePetitionGuidesPageData();
	const { translate } = useI18n();

	return {
		data: {
			canonicalUrl: 'https://www.change.org/petition-guides',
			description: translate('corgi.petition_guides_landing_page.meta.description'),
			title: translate('corgi.petition_guides_landing_page.meta.title'),
			image: heroImageUrl,
		},
	};
}
